<template>
  <main>
    <div class="container py-4">
      <section class="bg-white p-2 p-md-4 mb-4 rounded-lg">
        <header class="header">
          <div class="hero-section">
            <HeaderCarousel />
            <div class="flashpick">
              <HeaderCampaign />
            </div>
          </div>
        </header>

        <section class="" style="margin-top: 30px">
          <div class="popular d-flex align-items-center" style="gap: 30px">
            <div class="w-100">
              <PopularCategories class="h-100" />
            </div>
          </div>
        </section>

        <section style="margin-top: 30px">
          <NewArrivals />
        </section>

        <MainPageContent />
      </section>

      <section style="margin-top: 30px">
        <Partners />
      </section>
    </div>
  </main>
</template>

<script setup>
import HeaderCarousel from "../components/homepage/HeaderCarousel.vue";
import HeaderCampaign from "../components/homepage/HeaderCampaign.vue";
import PopularCategories from "../components/homepage/PopularCategories.vue";
import NewArrivals from "../components/homepage/NewArrivals.vue";
import MainPageContent from "../components/homepage/MainPageContent.vue";
import BlockLoader from "@/components/static/BlockLoader.vue";
import { useRoute } from "vue2-helpers/vue-router";
import { setCache } from "@/lib/affiliate";

import { defineAsyncComponent, onMounted } from "vue";
import useAnalytics from "@/composables/useAnalytics";

const route = useRoute();
const { trackAffiliateLink } = useAnalytics();

onMounted(() => {
  if (route.fullPath.includes("?")) {
    const affiliateId = route.query.aff || route.query.ref;

    if (affiliateId) {
      setCache("affiliate", affiliateId);
      trackAffiliateLink();
    }
  }
});

const Partners = defineAsyncComponent({
  loader: () => import("../components/homepage/Partners.vue"),
  loadingComponent: BlockLoader,
});
</script>

<style scoped>
.hero-section {
  display: flex;
  gap: 1rem;
}

.hero-section .flashpick {
  width: 35%;
}

@media screen and (max-width: 769px) {
  .hero-section {
    flex-direction: column;
    gap: 0.5rem;
  }

  .hero-section .flashpick {
    width: 100%;
  }
}

@media screen and (max-width: 900px) {
  .popular {
    flex-direction: column;
  }

  .arrival {
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .container {
    padding: 0 !important;
  }
}
</style>

<style>
header.header .hero-section .el-carousel {
  flex: 1;
  aspect-ratio: 2 / 1;
}

header.header .hero-section .el-carousel__container {
  height: 100%;
}

@media screen and (max-width: 769px) {
  header.header .hero-section .el-carousel {
    flex: unset;
  }
}
</style>
